import React, { useEffect } from 'react';
import {
  DataGridLayout,
  DESC,
  Filters,
  FiltersLayout,
  List,
  ListHeader,
  ListPageLayout,
  SearchInput,
} from 'framework/list';
import { FullDateField, TextField } from 'framework/ui/field';
import useProcessInstanceService, { ProcessState } from 'domain/gpo/cockpit/instance/processInstanceService';
import ProcessInstanceLinkField from 'domain/gpo/cockpit/instance/shared/ProcessInstanceLinkField';
import IncidentCountField from 'domain/gpo/cockpit/instance/shared/IncidentCountField';
import ProcessKeyFilter from 'domain/gpo/cockpit/instance/List/ProcessKeyFilter';
import ProcessStateField from 'domain/gpo/cockpit/instance/shared/ProcessStateField';
import ProcessDefinitionField from '../shared/ProcessDefinitionField';
import ProcessStateFilter from 'domain/gpo/cockpit/instance/List/ProcessStateFilter';

const ProcessInstanceListPage = () => {
  const { search, cacheProcessKeys } = useProcessInstanceService();

  useEffect(() => {
    cacheProcessKeys();
  }, [cacheProcessKeys]);

  return (
    <List
      getDataMethod={search}
      defaultSortField="startDateTime"
      defaultSortOrder={DESC}
      defaultFilter={{
        state: { eq: ProcessState.ACTIVE },
      }}
    >
      <ListPageLayout
        header={<ListHeader label="Process Instances" icon="fa-tasks" />}
        search={
          <SearchInput
            label="business key or ID"
            tooltipMessage="Note, that search by business key is case-sensitive."
          />
        }
        filter={
          <Filters>
            <FiltersLayout>
              <ProcessKeyFilter source="processKey" label="Process key" />
              <ProcessStateFilter source="state" label="Process state" />
            </FiltersLayout>
          </Filters>
        }
      >
        <DataGridLayout
          showTotal={false}
          isSmallTable
          rowProps={(instance: Dictionary<string>) => ({
            className: instance.incidentCount ? 'instance-with-incidents' : '',
          })}
        >
          <ProcessInstanceLinkField source="id" />
          <IncidentCountField source="incidentCount" label="Incidents" />
          <ProcessDefinitionField label="Process key / Version" keySource="processKey" versionSource="processVersion" />
          <TextField source="businessKey" label="Business key" />
          <ProcessStateField source="state" />
          <FullDateField source="startDateTime" label="Start date" isSortable />
          <FullDateField source="endDateTime" label="End date" isSortable />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default ProcessInstanceListPage;
